import { PageHeader } from '../components/PageHeader';
import { agentPersonas } from '../lib/seedData';

export function AgentLibraryPage() {
  return (
    <section className="page">
      <PageHeader title="Agent persona library" description="Reusable role definitions for orchestration planning." />
      <div className="grid cols-3">
        {agentPersonas.map((agent) => (
          <article className="card" key={agent.id}>
            <span className="badge good">{agent.role}</span>
            <h2 className="section-title">{agent.name}</h2>
            <p className="muted">{agent.description}</p>
            <strong>Strengths</strong>
            <p>{agent.strengths.join(', ')}</p>
          </article>
        ))}
      </div>
    </section>
  );
}
